import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import ManageEventsDialog from './ManageEventsDialog';
import { CheckSolidIcon, EditIcon, XSolidIcon, CachedIcon } from "../../../assets/icons/icons";
import { getFormatDate } from "../../../utils/CommonUtilities";
import { IconButton } from '@mui/material';
import './Events.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import useNotification from '../../../hooks/useNotification';

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

const EventCell = (params) => {
    return(
        <div>
            {/* {params.field === 'period' ? getFormatDate(params.value.SS[0]) + ' - ' + getFormatDate(params.value.SS[1]) : params.value.S} */}
            {params.value}
        </div>
    )
}

const ActionCell = (params, openDialog) => {
    return(
        <div>
            <IconButton onClick={()=>openDialog()} size='small'>
                <EditIcon addClass='pointer'></EditIcon>
            </IconButton>
        </div>
    )
}

const PhotoCell = (params) => {
    if(params.value){
        return <CheckSolidIcon addClass='green-txt'/>
    }else{
        return <XSolidIcon addClass='red-txt'/>
    }
}

const ActionHeaderCell = (getEvents) => {
    return(
        <div className="centered-cell" >
            <IconButton title='Ricarica dati' onClick={() => {getEvents()}} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
        </div>
    )
}

function Events(props) {
    const auth = useContext(AuthContext);
    const {events, setEvents} = useContext(AppAuthGlobalVariables);
    const { notificationError } = useNotification();

    const [loading, setLoading] = useState(true);
    const [eventsLoading, setEventsLoading] = useState(true);

    const [lastCellData, setLastCellData] = useState(null);
    const [openManageEventsDialog, setOpenManageEventsDialog] = useState(false);

    const columns = [
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 75, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, renderCell: (params) => ActionCell(params, handleOpenManageEventDialog), renderHeader: (params) => ActionHeaderCell(getEvents)},
        {field: 'itname', headerClassName: 'header-cell itname', headerName: 'Nome', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => EventCell(params), valueGetter: (params) => params?.S},
        {field: 'categoria', headerClassName: 'header-cell categoria', headerName: 'Categoria', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => EventCell(params), valueGetter: (params) => params?.S},
        {field: 'location', headerClassName: 'header-cell location', headerName: 'Luogo', type: 'string', width: 300, align: 'left', headerAlign: 'left', renderCell: (params) => EventCell(params), valueGetter: (params) => params?.S},
        {field: 'period', headerClassName: 'header-cell period', headerName: 'Durata', type: 'string', width: 200, align: 'center', headerAlign: 'center', renderCell: (params) => EventCell(params), valueGetter: (params) => getFormatDate(params?.SS[0]) + ' - ' + getFormatDate(params?.SS[1]) || ''},
        {field: 'lat', headerClassName: 'header-cell latitude', headerName: 'Latitudine', type: 'string', width: 200, align: 'right', headerAlign: 'right', renderCell: (params) => EventCell(params), valueGetter: (params) => params?.S},
        {field: 'lon', headerClassName: 'header-cell longitude', headerName: 'Longitudine', type: 'string', width: 200, align: 'right', headerAlign: 'right', renderCell: (params) => EventCell(params), valueGetter: (params) => params?.S},
        {field: 'photo', headerClassName: 'header-cell photo', headerName: 'Foto', type: 'string', width: 100, align: 'center', headerAlign: 'center', renderCell: (params) => PhotoCell(params), valueGetter: (params) => params?.S},
    ]

    useEffect(() => {
        if(!events.length){
            getEvents();
        }else{
            setEventsLoading(false);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        if(!loading){
            getEvents();
        }
    }, [props.city])

    const getEvents = async() => {
        try {
            setLoading(true);
            setEventsLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-events',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            /* setRows(response.data.result.Items); */
            setEvents(response?.data?.result?.Items)
            setEventsLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setEventsLoading(false);
            setLoading(false);
        }
    }

    const handleOpenManageEventDialog = () => {
        setOpenManageEventsDialog(true);
    }

    const handleCloseManageEventDialog = () => {
        setOpenManageEventsDialog(false);
    }

    return (
        <div className='component-container events'>
            <div className='component-card'>
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={events}
                        columns={columns}
                        className="events-table"
                        loading={eventsLoading}
                        rowHeight={30}
                        onCellClick={(params) => setLastCellData(params.row)}
                        initialState={{ pinnedColumns: { left: ['ACTION'], right: [] } }}
                        getCellClassName={(params) => {
                            if(params.field==="ACTION"){
                                return 'centered-cell';
                            }
                        }}
                        getRowId={(row) => row.idEntita.S}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                        hideFooter
                    />
                </ThemeProvider>
                <ManageEventsDialog {...{
                    openManageEventsDialog,
                    handleCloseManageEventDialog,
                    lastCellData,
                    getEvents
                }}/>
            </div>
        </div>
    )
}

export default Events